import { isAllergenViolation } from "@chef/helpers";
import { Skeleton } from "@chef/components";
import {
  useAppDispatch,
  useExtendedBasketData,
} from "@chef/state-management/hooks";
import { openModal } from "@chef/state-management";

import type { WeekYear } from "@chef/types/common";

import { PreferenceWarningSnackbar } from "../PreferenceWarningSnackbar";
import { MyMenuCards } from "./MyMenuCards";
import { MyMenuOptions } from "./MyMenuOptions";
import { EditModeButton } from "../EditModeButton";

import { intl } from "./WeekOverviewExperimental.Intl";

export const WeekOverviewExperimental = ({ week, year }: WeekYear) => {
  const dispatch = useAppDispatch();

  const {
    data: extendedBasketData,
    isError: isErrorExtendedBasketData,
    isLoading: isLoadingExtendedBasketData,
  } = useExtendedBasketData({ week, year });

  const portions = extendedBasketData.portions;
  const meals = extendedBasketData.meals;

  const selectedProducts = extendedBasketData?.selectedProducts || [];

  if (!extendedBasketData.mealboxProduct || isLoadingExtendedBasketData) {
    return (
      <>
        <div className="col-span-full">
          <Skeleton height={12} width={80} className="mb-2" />
          <Skeleton width={64} className="mb-2" />
          <div className="flex mb-2">
            <Skeleton width={16} className="mr-4" />
            <Skeleton width={16} className="mr-4" />
          </div>
        </div>
        <section className="grid grid-cols-2 gap-4 col-span-full lg:grid-cols-5">
          {[...Array(5)].map((_, i) => {
            return (
              <div className="flex flex-col gap-2 aspect-1/2" key={i}>
                <Skeleton height="80%" />
                <Skeleton width="33%" height={6} />
                <Skeleton width="67%" height={4} />
                <Skeleton width="50%" height={4} />
              </div>
            );
          })}
        </section>
      </>
    );
  }

  if (!meals || !portions || isErrorExtendedBasketData) {
    return null;
  }

  const showPreferenceError = selectedProducts.some((product) =>
    isAllergenViolation(product.allergenComplianceId),
  );

  const onHandleChangeNumPortions = () => {
    dispatch(
      openModal({
        id: "WEEK_PORTION",
        week,
        year,
      }),
    );
  };
  const mealsMessage = `${meals} ${intl.MEALS},`;
  const portionsMessage = ` ${portions} ${intl.PEOPLE}`;

  return (
    <>
      <div className="col-span-full">
        <PreferenceWarningSnackbar show={showPreferenceError} />

        <div className="flex flex-col md:flex-row md:justify-between md:items-center">
          <div className="mb-2">
            <h1>
              <strong>
                {intl.MEAL} {intl.WEEK} {week}
              </strong>
            </h1>
            <div className="mt-2 text-sm">
              {mealsMessage}
              <button
                type="button"
                className="underline"
                onClick={onHandleChangeNumPortions}
              >
                {portionsMessage}
              </button>
            </div>
          </div>

          <EditModeButton
            week={week}
            year={year}
            scrollToId="menu-options-section"
          />
        </div>

        <MyMenuCards week={week} year={year} />
        <MyMenuOptions week={week} year={year} />
      </div>
    </>
  );
};
